import { memo } from 'react';
import { CartContainer, EntityList } from '@aimsos/ui';
import { StatusPill } from '../../../components';

/**
 * One instance row in the Overview tab's instance list. Extracted (and
 * memoized) so the inline `primaryMeta`/`primaryCta` array/object construction
 * EntityList needs doesn't run — and doesn't defeat EntityList's own memo — on
 * every OverviewTab render. Only re-renders when its own props actually change.
 */
function InstanceRow({ instance, canManageIntegrations, onOpen, openLabel }) {
  return (
    <CartContainer size="M">
      <EntityList
        title={instance.name}
        primaryMeta={[{ icon: <StatusPill status={instance.status} /> }]}
        primaryCta={
          canManageIntegrations
            ? { label: openLabel, variant: 'tertiary', onClick: () => onOpen(instance.id) }
            : undefined
        }
      />
    </CartContainer>
  );
}

export default memo(InstanceRow);
